import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { currencyInitialState, CurrencyStateProps, currencyStateStore } from './currency-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class CurrencyRepository extends BaseStoreRepository<CurrencyStateProps> {
  constructor() {
    super(currencyStateStore.pipe(select(state => state)), currencyStateStore, currencyInitialState);
  }
}
